module.exports = __webpack_public_path__ + "static/media/30_A.68253b47.png";